module.exports = __webpack_public_path__ + "media/metronic/_theme/media/project-logos/1-b643b623490a5509caf055ff26727420.png";